import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LANGUAGES, DEFAULT_LANG } from "../constants/all-language";
// import { Pathname } from "../pathname"; // Removed - should be passed as props

export function Header(): React.ReactElement {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const onChangeLang = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const lang_code = e.target.value;
    const currentLangObj = LANGUAGES.find((lang) => lang.code === lang_code);
    if (currentLangObj?.dir) {
      document.body.dir = currentLangObj.dir || "ltr";
    }
    i18n.changeLanguage(lang_code);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        backgroundColor: "lightblue",
        padding: "1.5rem",
        marginBottom: "2rem",
      }}
    >
      <div>
        <button
          style={{
            backgroundColor: "lightblue",
            margin: "0 1.5rem",
            outline: "none",
          }}
          onClick={() => navigate(Pathname.LANDING_PAGE)}
        >
          {t("navbar.home")}
        </button>
        {localStorage.getItem("_tid") && (
          <button
            style={{
              backgroundColor: "lightblue",
              margin: "0 1.5rem",
              outline: "none",
            }}
            onClick={() => navigate(Pathname.DASHBOARD)}
          >
            {t("navbar.dashboard")}
          </button>
        )}
        <button
          style={{
            backgroundColor: "lightblue",
            margin: "0 1.5rem",
            outline: "none",
          }}
          onClick={() => navigate(Pathname.DASHBOARD_QUOTES)}
        >
          {t("navbar.quotes")}
        </button>
        <button
          style={{
            backgroundColor: "lightblue",
            margin: "0 1.5rem",
            outline: "none",
          }}
          onClick={() => navigate(Pathname.DASHBOARD_DOCUMENT)}
        >
          {t("navbar.document")}
        </button>
        <button
          style={{
            backgroundColor: "lightblue",
            margin: "0 1.5rem",
            outline: "none",
          }}
          onClick={() => navigate(Pathname.DASHBOARD_USER)}
        >
          {t("navbar.user")}
        </button>
      </div>
      <div style={{ display: "flex" }}>
        <div>
          {localStorage.getItem("_tid") ? (
            <button
              style={{
                backgroundColor: "lightblue",
                margin: "0 1.5rem",
                outline: "none",
              }}
              onClick={() => {
                localStorage.removeItem("_tid");
                localStorage.removeItem("role-permission");
                navigate(Pathname.LOGIN);
              }}
            >
              {t("navbar.logout")}
            </button>
          ) : (
            <button
              style={{
                backgroundColor: "lightblue",
                margin: "0 1.5rem",
                outline: "none",
              }}
              onClick={() => {
                localStorage.setItem("_tid", "test token");
                navigate(Pathname.DASHBOARD);
              }}
            >
              {t("navbar.login")}
            </button>
          )}
        </div>
        <select defaultValue={DEFAULT_LANG} onChange={onChangeLang}>
          {LANGUAGES.map(({ code, label }) => (
            <option key={code} value={code}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}


export default Header;
